import EntityDisplay from '../EntityElements/EntityDisplay';
import { HUB_PLAYER_SPRITES } from '../../../data/hub.config';
import type { PresenceState } from '../../../net/hubPresence';

// Y flipped at the call site (position: { x, y: -y }), matching HubPlayerSprite's convention.
export const RemoteHubAvatars = ({ avatars }: { avatars: PresenceState[] }) => (
  <>
    {avatars.map((a) => (
      <EntityDisplay
        key={a.peerId}
        clip={{
          spriteName: a.moving
            ? HUB_PLAYER_SPRITES.run
            : HUB_PLAYER_SPRITES.idle,
          direction: a.direction,
          width: HUB_PLAYER_SPRITES.width,
          height: HUB_PLAYER_SPRITES.height,
          anchor: HUB_PLAYER_SPRITES.anchor as [number, number],
          loop: true,
        }}
        position={{ x: a.x, y: -a.y }}
      />
    ))}
  </>
);
